import { VueConstructor } from 'vue';

import error from './components/error/error.vue';
import paccordiongroup from './components/p-accordion/p-accordion-group.vue';
import paccordion from './components/p-accordion/p-accordion.vue';
import palert from './components/p-alert/p-alert.vue';
import papp from './components/p-app/p-app.vue';
import pautocomplete from './components/p-autocomplete/p-autocomplete.vue';
import pbadge from './components/p-badge/p-badge.vue';
import pbreadcrumbbutton from './components/p-breadcrumb/p-breadcrumb-button.vue';
import pbreadcrumbdot from './components/p-breadcrumb/p-breadcrumb-dot.vue';
import pbreadcrumbpath from './components/p-breadcrumb/p-breadcrumb-path.vue';
import pbreadcrumb from './components/p-breadcrumb/p-breadcrumb.vue';
import pbutton from './components/p-button/p-button.vue';
import pcard from './components/p-card/p-card.vue';
import pcheckbox from './components/p-checkbox/p-checkbox.vue';
import pcheckboxgroup from './components/p-checkbox-group/p-checkbox-group.vue';
import pcode from './components/p-code/p-code.vue';
import pcol from './components/p-col/p-col.vue';
import pconditionalwrapper from './components/p-conditional-wrapper/p-conditional-wrapper.vue';
import pcontainer from './components/p-container/p-container.vue';
import pcurrencyfield from './components/p-currency-field/p-currency-field.vue';
import pdatefield from './components/p-date-field/p-date-field.vue';
import pdatedaypicker from './components/p-date-picker/p-date-day-picker.vue';
import pdatemonthpicker from './components/p-date-picker/p-date-month-picker.vue';
import pdatepicker from './components/p-date-picker/p-date-picker.vue';
import pdateweekpicker from './components/p-date-picker/p-date-week-picker.vue';
import pdatetimefield from './components/p-date-time-field/p-date-time-field.vue';
import pdialogconfirmdelete from './components/p-dialog/p-dialog-confirm-delete.vue';
import pdialogconfirm from './components/p-dialog/p-dialog-confirm.vue';
import pdialognotify from './components/p-dialog/p-dialog-notify.vue';
import pdialogprompt from './components/p-dialog/p-dialog-prompt.vue';
import pdialog from './components/p-dialog/p-dialog.vue';
import pdivider from './components/p-divider/p-divider.vue';
import pdynamicform from './components/p-dynamic-form/p-dynamic-form.vue';
import pdynamicformfields from './components/p-dynamic-form-fields/p-dynamic-form-fields.vue';
import pfieldset from './components/p-fieldset/p-fieldset.vue';
import pfiledrop from './components/p-file-drop/p-file-drop.vue';
import pfileselection from './components/p-file-selection/p-file-selection.vue';
import pformelementmessages from './components/p-form/p-form-element-messages.vue';
import pformelement from './components/p-form/p-form-element.vue';
import pform from './components/p-form/p-form.vue';
import picon from './components/p-icon/p-icon.vue';
import pimg from './components/p-img/p-img.vue';
import plistentry from './components/p-list/p-list-entry.vue';
import plistgroup from './components/p-list/p-list-group.vue';
import plist from './components/p-list/p-list.vue';
import plistview from './components/p-list-view/p-list-view.vue';
import plocation from './components/p-location/p-location.vue';
import plookup from './components/p-lookup/p-lookup.vue';
import pmenu from './components/p-menu/p-menu.vue';
import pnumberfield from './components/p-number-field/p-number-field.vue';
import poverlay from './components/p-overlay/p-overlay.vue';
import ppagination from './components/p-pagination/p-pagination.vue';
import pchild from './components/p-parent/p-child.vue';
import pparent from './components/p-parent/p-parent.vue';
import pphonefield from './components/p-phone-field/p-phone-field.vue';
import ppill from './components/p-pill/p-pill.vue';
import pprogresscircular from './components/p-progress-circular/p-progress-circular.vue';
import pprogresslinear from './components/p-progress-linear/p-progress-linear.vue';
import pradiofield from './components/p-radio-field/p-radio-field.vue';
import pratio from './components/p-ratio/p-ratio.vue';
import prequestalert from './components/p-request-alert/p-request-alert.vue';
import presizable from './components/p-resizable/p-resizable.vue';
import prootportal from './components/p-root-portal/p-root-portal.vue';
import prow from './components/p-row/p-row.vue';
import pselect from './components/p-select/p-select.vue';
import pselectmultiple from './components/p-select-multiple/p-select-multiple.vue';
import pselectionchild from './components/p-selection-parent/p-selection-child.vue';
import pselectionparent from './components/p-selection-parent/p-selection-parent.vue';
import psidedrawer from './components/p-side-drawer/p-side-drawer.vue';
import psurface from './components/p-surface/p-surface.vue';
import ptable from './components/p-table/p-table.vue';
import ptab from './components/p-tabs/p-tab.vue';
import ptabs from './components/p-tabs/p-tabs.vue';
import ptextfield from './components/p-text-field/p-text-field.vue';
import ptextfieldformatted from './components/p-text-field-formatted/p-text-field-formatted.vue';
import ptextarea from './components/p-textarea/p-textarea.vue';
import ptimefield from './components/p-time-field/p-time-field.vue';
import ptoggle from './components/p-toggle/p-toggle.vue';
import ptoolbar from './components/p-toolbar/p-toolbar.vue';
import pfadetransition from './components/p-transition/p-fade-transition.vue';
import pscaletransition from './components/p-transition/p-scale-transition.vue';
import pscrollxreversetransition from './components/p-transition/p-scroll-x-reverse-transition.vue';
import pscrollxtransition from './components/p-transition/p-scroll-x-transition.vue';
import pscrollyreversetransition from './components/p-transition/p-scroll-y-reverse-transition.vue';
import pscrollytransition from './components/p-transition/p-scroll-y-transition.vue';
import pslidexreversetransition from './components/p-transition/p-slide-x-reverse-transition.vue';
import pslidextransition from './components/p-transition/p-slide-x-transition.vue';
import pslideyreversetransition from './components/p-transition/p-slide-y-reverse-transition.vue';
import pslideytransition from './components/p-transition/p-slide-y-transition.vue';

export default {
  install: (Vue: VueConstructor, options: any) => {
    Vue.component('Error', error);
    Vue.component('PAccordionGroup', paccordiongroup);
    Vue.component('PAccordion', paccordion);
    Vue.component('PAlert', palert);
    Vue.component('PApp', papp);
    Vue.component('PAutocomplete', pautocomplete);
    Vue.component('PBadge', pbadge);
    Vue.component('PBreadcrumbButton', pbreadcrumbbutton);
    Vue.component('PBreadcrumbDot', pbreadcrumbdot);
    Vue.component('PBreadcrumbPath', pbreadcrumbpath);
    Vue.component('PBreadcrumb', pbreadcrumb);
    Vue.component('PButton', pbutton);
    Vue.component('PCard', pcard);
    Vue.component('PCheckbox', pcheckbox);
    Vue.component('PCheckboxGroup', pcheckboxgroup);
    Vue.component('PCode', pcode);
    Vue.component('PCol', pcol);
    Vue.component('PConditionalWrapper', pconditionalwrapper);
    Vue.component('PContainer', pcontainer);
    Vue.component('PCurrencyField', pcurrencyfield);
    Vue.component('PDateField', pdatefield);
    Vue.component('PDateDayPicker', pdatedaypicker);
    Vue.component('PDateMonthPicker', pdatemonthpicker);
    Vue.component('PDatePicker', pdatepicker);
    Vue.component('PDateWeekPicker', pdateweekpicker);
    Vue.component('PDateTimeField', pdatetimefield);
    Vue.component('PDialogConfirmDelete', pdialogconfirmdelete);
    Vue.component('PDialogConfirm', pdialogconfirm);
    Vue.component('PDialogNotify', pdialognotify);
    Vue.component('PDialogPrompt', pdialogprompt);
    Vue.component('PDialog', pdialog);
    Vue.component('PDivider', pdivider);
    Vue.component('PDynamicForm', pdynamicform);
    Vue.component('PDynamicFormFields', pdynamicformfields);
    Vue.component('PFieldset', pfieldset);
    Vue.component('PFileDrop', pfiledrop);
    Vue.component('PFileSelection', pfileselection);
    Vue.component('PFormElementMessages', pformelementmessages);
    Vue.component('PFormElement', pformelement);
    Vue.component('PForm', pform);
    Vue.component('PIcon', picon);
    Vue.component('PImg', pimg);
    Vue.component('PListEntry', plistentry);
    Vue.component('PListGroup', plistgroup);
    Vue.component('PList', plist);
    Vue.component('PListView', plistview);
    Vue.component('PLocation', plocation);
    Vue.component('PLookup', plookup);
    Vue.component('PMenu', pmenu);
    Vue.component('PNumberField', pnumberfield);
    Vue.component('POverlay', poverlay);
    Vue.component('PPagination', ppagination);
    Vue.component('PChild', pchild);
    Vue.component('PParent', pparent);
    Vue.component('PPhoneField', pphonefield);
    Vue.component('PPill', ppill);
    Vue.component('PProgressCircular', pprogresscircular);
    Vue.component('PProgressLinear', pprogresslinear);
    Vue.component('PRadioField', pradiofield);
    Vue.component('PRatio', pratio);
    Vue.component('PRequestAlert', prequestalert);
    Vue.component('PResizable', presizable);
    Vue.component('PRootPortal', prootportal);
    Vue.component('PRow', prow);
    Vue.component('PSelect', pselect);
    Vue.component('PSelectMultiple', pselectmultiple);
    Vue.component('PSelectionChild', pselectionchild);
    Vue.component('PSelectionParent', pselectionparent);
    Vue.component('PSideDrawer', psidedrawer);
    Vue.component('PSurface', psurface);
    Vue.component('PTable', ptable);
    Vue.component('PTab', ptab);
    Vue.component('PTabs', ptabs);
    Vue.component('PTextField', ptextfield);
    Vue.component('PTextFieldFormatted', ptextfieldformatted);
    Vue.component('PTextarea', ptextarea);
    Vue.component('PTimeField', ptimefield);
    Vue.component('PToggle', ptoggle);
    Vue.component('PToolbar', ptoolbar);
    Vue.component('PFadeTransition', pfadetransition);
    Vue.component('PScaleTransition', pscaletransition);
    Vue.component('PScrollXReverseTransition', pscrollxreversetransition);
    Vue.component('PScrollXTransition', pscrollxtransition);
    Vue.component('PScrollYReverseTransition', pscrollyreversetransition);
    Vue.component('PScrollYTransition', pscrollytransition);
    Vue.component('PSlideXReverseTransition', pslidexreversetransition);
    Vue.component('PSlideXTransition', pslidextransition);
    Vue.component('PSlideYReverseTransition', pslideyreversetransition);
    Vue.component('PSlideYTransition', pslideytransition);
  },
};
